const ADMIN_NOTIFICATION_EVENT = 'admin-notification-signal';

const adminNotificationMixin = {
    mounted() {
        this._onAdminNotificationSignal = (event) => {
            if (typeof this.onAdminNotification === 'function') {
                this.onAdminNotification(event);
            }
        };

        this.$root.$on(
            ADMIN_NOTIFICATION_EVENT,
            this._onAdminNotificationSignal,
        );
    },
    beforeDestroy() {
        if (this._onAdminNotificationSignal) {
            this.$root.$off(
                ADMIN_NOTIFICATION_EVENT,
                this._onAdminNotificationSignal,
            );
        }
    },
};

export { ADMIN_NOTIFICATION_EVENT };
export default adminNotificationMixin;
